import {ClsAccessToken} from '../cls-access-token';
import {ClsErrores} from '../cls-errores';

export class ClsPeticionPresupuestos {
  AccessToken: ClsAccessToken;
  IdPresupuesto?: bigint;
  IdPresupuestoMaestro?: bigint;
  IdOrganizacion?: bigint;
  IdUsuario?: bigint;
}

export class ClsValidaFechasConsultas {
  Estatus: boolean;
  Errores: ClsErrores;
}

export class ClsRespuestaFechasConsultas {
  FechaCatalogo: Date;
  FechaMatrices: Date;
  Errores: ClsErrores;
}

export class ClsRespuestaCatMatrizStorage {
  Catalogo: string;
  Matrices: string;
  Errores: ClsErrores;
}
export class ClsPeticionObtieneUltimoModifico extends ClsPeticionPresupuestos {
  Opcion: number;
  IdBusqueda: bigint;
  IdPresupuesto: bigint;
}

export class ClsRespuestaUltimoModifico {
  Usuario: string;
  FechaEdicion: Date;
  Errores?: ClsErrores;
}

export class ClsRespuesaOtraOrganizacion {
  // esta bandera sirve para validar si el usuario cambio de organización, ya sea que este creando o abriendo algun ppto
  // se actualice el sistema o se migre el ppto
  EsOtraOrganizacion?: boolean;
  IdOrganizacionNuevo?: bigint;
  Errores: ClsErrores;
}

export class ClsFormatosDocumentos {
  pdf: string;
  xlsx: string;
}

export class ClsPeticionGenerarArchivoIntercambio extends ClsPeticionPresupuestos {
  ExportarTodo: boolean;
  ExportInsumos: boolean;
  ExportMatrices: boolean;
  ExportProgObra: boolean;
  IdPrograma: bigint;
  ExportLibroFASAR: boolean;
  ExportLibroSobrecosto: boolean;
  ExportLibroIndirectos: boolean;
  ExportarTodasMonedas: boolean;
  ExportMoneda1: boolean;
  ExportMoneda2: boolean;
}
